var _rect, _rect2, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "#F4F4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#DEDEDE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 26.5,
    r: 9.5,
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 34.5,
    r: 12.5,
    fill: "#F4F4F4",
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1303 43.1996L22 29.1042L27.971 26.931C31.2591 25.7342 33.9991 26.9858 35.0407 29.8477C36.1036 32.768 34.7405 35.4249 31.3919 36.6437L28.9511 37.5321L30.5596 41.9515L27.1303 43.1996ZM27.9944 34.9038L29.8099 34.243C31.4237 33.6556 31.9723 32.4638 31.4904 31.1399C31.0086 29.8161 29.8365 29.2946 28.2227 29.882L26.4072 30.5428L27.9944 34.9038Z",
    fill: "#11B55F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointChat);
export default __webpack_public_path__ + "static/media/pointChat.219efa6a86c4dd0a9b4a65ef51723961.svg";
export { ForwardRef as ReactComponent };